import { useRef } from 'react';
import Image from 'next/image';
import gsap from "gsap";
import { useGSAP } from '@gsap/react';


// interface HomeInfoProps {
//   image: { url: string };
//   title: string;
//   text: string;
// }

const HomeInfo = ({title, text, image, people}) => {
  

    const imageParallax = useRef(null)
    const imageParallaxWrapper = useRef(null)
    const sectionRef = useRef(null)

    const containerRef = useRef(null)

    const subInfo1 = useRef(null)
    const subInfo2 = useRef(null)

    const headerRef = useRef(null)
    const textRef = useRef(null)

    useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {



        gsap.fromTo(textRef.current, {
          opacity: 0
          },
           {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 50%",
          },
        });

        gsap.fromTo(headerRef.current, {
          opacity: 0
          },
           {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 60%",
          },
        });

        gsap.fromTo(subInfo1.current, {
          opacity: 0
          },
           {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 55%",
          },
        });

        gsap.fromTo(subInfo2.current, {
          opacity: 0
          },
           {
          opacity: 1,
          duration: 1,
          delay:0.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 55%",
          },
        });

        gsap.fromTo(containerRef.current, {
          y: '20rem'
        },
           {
          y: 0,
          ease: 'power1.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top bottom", 
            end: "top 50%",  
            scrub: 0.1,  
          },
        });

        gsap.fromTo(imageParallax.current, {
          y: '-10vh'
        },
           {
          y: '10vh',
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top bottom", 
            end: "bottom 20%",  
            scrub: 0,  
          },
        });


        // gsap.fromTo(imageParallaxWrapper.current, 
        //   { y: "55vh" }, 
        //   {
        //     y: 0,
        //     ease: "none",
        //     scrollTrigger: {
        //       trigger: sectionRef.current,
        //       start: "top bottom",
        //       end: "top 20%",
        //       scrub: 0.1,
        //     }
        //   }
        // )


        gsap.fromTo(headerRef.current, 
          { y: "12vh" }, 
          {
            y: "-6vh",
            ease: "none",
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top bottom", 
              end: "bottom 20%",  
              scrub: 0.1,
            }
          }
        )

        gsap.fromTo(textRef.current, 
          { y: "12vh" }, 
          {
            y: "-6vh",
            ease: "none",
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top bottom", 
              end: "bottom 20%",  
              scrub: 0.1,
            }
          }
        )
      
      })

        



    return () => mm.revert(); // cleanup
  }, {scope: sectionRef});




  return (
    <section ref={sectionRef} className="container-max pb-[4rem] md:pb-[5rem] lg:pb-[6rem] xl:pb-[8rem] pt-[2rem] md:pt-[2rem] lg:pt-[2rem] xl:pt-[2rem] container-padding  w-full">
      <div ref={containerRef} className='flex-col  container-grid w-full'>
        
        <div className='lg:hidden md:col-span-2 w-full mb-[3.2rem] md:mb-[4rem] px-[4.4rem] md:px-0'>
          <div className="relative pb-[calc(100/0.77)%] w-full aspect-[0.77/1] ">
            <Image
              src={image?.url}
              alt={image?.alt}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw"
              className="w-auto object-cover"
            />
          </div>
        </div>

        <h2 className=' mb-[3.2rem] heading-3 md:hidden [&>.selected]:italic [&>.selected]:text-dusty-blue-light' dangerouslySetInnerHTML={{__html: title}}/>

        <div  ref={headerRef} className='relative z-10 md:col-span-2 md:col-start-4 lg:col-start-1 lg:col-span-4 text-end w-full flex flex-col'>
          <h2 className='hidden heading-3 md:mt-[4rem] md:text-left lg:text-right lg:mt-[9rem] lg:mb-[6.4rem] md:inline-block mb-[3.2rem] [&>.selected]:italic [&>.selected]:text-dusty-blue-light' dangerouslySetInnerHTML={{__html: title}}/>

      
          <div ref={subInfo1} className=' mb-[4rem] z-10 flex relative justify-end md:justify-start lg:justify-end  md:pl-[10rem] w-full'>


             
              <div className='absolute md:right-auto  md:left-[-4rem] lg:left-auto  md:top-[-4rem]  top-[-4rem] xl:w-[20rem] xl:h-[20rem]  xl:right-[-18rem] xl:top-[-8rem] right-[21rem] w-[15rem]  h-[12rem] lg:right-[-14.5rem] lg:top-[-6rem] md:w-[14rem] md:h-[14rem] lg:h-[14rem] lg:w-[14rem]'>
                <Image
                  src={people?.[0]?.sign?.url}
                  alt={people?.[0]?.sign?.alt}
                  fill
                  sizes="300px"
                  className="w-auto object-cover"
                />
              </div>
              <div className='text-left lg:text-right w-[20.9rem] lg:w-auto'>
                <p className='text-1'>{people?.[0]?.name},</p>
                <p className='text-1'>{people?.[0]?.position}</p>
              </div>
          </div>

          <div ref={subInfo2} className='flex relative z-10 justify-end md:justify-start md:pl-[10rem]  lg:justify-end w-full'>
            <div className='absolute right-[22rem] lg:top-[-5rem]   lg:h-[14rem] lg:w-[14rem] xl:w-[20rem] xl:h-[20rem] xl:right-[-18rem] xl:top-[-5rem] md:w-[14rem] md:h-[14rem] md:right-auto lg:left-auto  lg:right-[-14.5rem] top-[-1rem] md:top-0 md:left-[-5rem] h-[11rem] w-[13rem]'>
              <Image
                  src={people?.[1]?.sign?.url}
                  alt={people?.[1]?.sign?.alt}
                fill
                sizes="300px"
                className="w-auto object-cover"
              />
            </div>

            <div className='text-left lg:text-right w-[20.9rem] lg:w-auto'>
              <p className='text-1'>{people?.[1]?.name},</p>
              <p className='text-1'>{people?.[1]?.position}</p>
            </div>
          </div>

        </div>

        <div className='hidden lg:block col-span-4 col-start-6 lg:mb-0 w-full mb-[3.2rem] md:mb-[4rem] px-[4.4rem] md:px-0'>
          <div ref={imageParallaxWrapper} className="relative flex items-center justify-center overflow-hidden w-full aspect-[0.77/1] lg:aspect-[0.69/1] ">
            <div ref={imageParallax} className='relative w-full h-[140%]'>
              <Image
                src={image?.url}
                alt={image?.alt}
                fill
                sizes="600px"
                className="w-auto object-cover"
              />
            </div>

          </div>
        </div>

        <div ref={textRef} className='flex md:hidden flex-col lg:h-full lg:justify-start lg:pt-[13.2rem] xl:pt-[14.6rem] lg:pl-[16%] lg:col-span-3 lg:col-start-10 lg:flex pt-[4rem] md:pt-0 gap-[1.6rem]'>
          {text?.map((item, index)=> (<p className='text-1' key={index}>
            {item.about_hp_text}
          </p>))}
        </div>



        <p className='hidden md:inline-block text-1 col-span-2 lg:hidden'>{text?.[0]?.about_hp_text}</p>
        <p className='hidden md:inline-block text-1 col-span-2 col-start-4 lg:hidden'>{text?.[1]?.about_hp_text}</p>


      </div>
    </section>
  );
};

export default HomeInfo;